import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function useTitle() {
  const location = useLocation();

  useEffect(() => {
    const baseTitle = "Marléna Mendoza";
    let title = baseTitle;

    switch (location.pathname) {
      case "/":
        title = baseTitle;
        break;
      case "/about":
        title = "About | " + baseTitle;
        break;
      case "/work":
        title = "Gallery | " + baseTitle;
        break;
      case "/inquiry":
        title = "Book An Appointment | " + baseTitle;
        break;
      case "/aftercare":
        title = "Tattoo Aftercare | " + baseTitle;
        break;
      case "/admin-login":
        title = "Login | " + baseTitle;
        break;
      case "/admin":
        title = "Admin | " + baseTitle;
        break;
      case "/admin/inquiry/:id":
        title = "Inquiry Info | " + baseTitle;
        break;
      default:
        title = baseTitle;
        break;
    }

    document.title = title;
  }, [location]);
}

export default useTitle;
